import EmergencyMessage from './EmergencyMessage';

export default EmergencyMessage;
